import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop: React.FC = () => {
  const { pathname, hash, key } = useLocation()

  useEffect(() => {
    const scrollToTop = () => {
      // Scroll both window and document elements for better compatibility
      window.scrollTo(0, 0)
      if (document.documentElement) {
        document.documentElement.scrollTop = 0
      }
      if (document.body) {
        document.body.scrollTop = 0
      }

      // Also handle any scrollable containers
      const scrollableElements = document.querySelectorAll(
        '[data-scroll-container]'
      )
      Array.from(scrollableElements).forEach((element) => {
        const htmlElement = element as HTMLElement
        if (htmlElement?.scrollTop !== undefined) {
          htmlElement.scrollTop = 0
        }
      })
    }

    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      scrollToTop()
    })

    // Also try after delays to catch lazy-loaded content
    const timeout1 = setTimeout(scrollToTop, 0)
    const timeout2 = setTimeout(scrollToTop, 100)
    const timeout3 = setTimeout(scrollToTop, 300)

    return () => {
      clearTimeout(timeout1)
      clearTimeout(timeout2)
      clearTimeout(timeout3)
    }
  }, [pathname, hash, key])

  // Also listen to hash changes for hash-based routing
  useEffect(() => {
    const handleHashChange = () => {
      requestAnimationFrame(() => {
        window.scrollTo(0, 0)
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      })
    }

    window.addEventListener('hashchange', handleHashChange)
    return () => {
      window.removeEventListener('hashchange', handleHashChange)
    }
  }, [])

  return null
}

export default ScrollToTop
